import { apiClient } from '@/lib/api/client'
import type {
  CatalogAttributesPayload,
  CatalogOptionsPayload,
  CatalogRenderRequest,
  CatalogRenderResponse,
  CatalogTranslationsPayload,
} from '@/types/catalog-translations'

/**
 * Read-only admin endpoints (Phase 4) for the catalog translations consultation
 * page. All require the `settings:manage` permission server-side.
 */

export async function getCatalogTranslations(): Promise<CatalogTranslationsPayload> {
  return apiClient.get<CatalogTranslationsPayload>('/admin/catalog/translations')
}

export async function renderCatalogTranslations(
  request: CatalogRenderRequest
): Promise<CatalogRenderResponse> {
  return apiClient.post<CatalogRenderResponse>('/admin/catalog/translations/render', request)
}

export async function getCatalogAttributes(): Promise<CatalogAttributesPayload> {
  return apiClient.get<CatalogAttributesPayload>('/admin/catalog/attributes')
}

export async function getCatalogOptions(): Promise<CatalogOptionsPayload> {
  return apiClient.get<CatalogOptionsPayload>('/admin/catalog/options')
}
